import React from 'react';
import { Typography } from '@material-ui/core';
import DialogDefault from '../common/DialogDefault';

const ModalConfirmDelete = ({
	openDeleteConfirmModal,
	toggleOpenDeleteConfirmModal,
	handleDelete,
	selectedName,
}) => {
	const submitData = (e) => {
		e.preventDefault();
		toggleOpenDeleteConfirmModal();
		handleDelete();
	};

	return (
		<DialogDefault
			headline="Löschen"
			openModal={openDeleteConfirmModal}
			closeModal={toggleOpenDeleteConfirmModal}
			confirmButton={(e) => submitData(e)}
			confirmButtonText="Löschen"
		>
			<Typography>
				<strong>„{selectedName}“ wirklich löschen?</strong>
			</Typography>
			<Typography>
				Gelöschte Daten können nicht wiederhergestellt werden!
			</Typography>
		</DialogDefault>
	);
};

export default ModalConfirmDelete;
